define(["require", "exports", "tslib", "@date-io/moment", "@material-ui/core/CssBaseline", "@material-ui/core/styles", "@material-ui/pickers", "mobx", "mobx-react", "react", "react-dom", "react-hot-loader", "react-router-dom", "./store", "./store/RouteStore", "./utils/Environment", "./utils/RequestLogger", "core-js"], function (require, exports, tslib_1, moment_1, CssBaseline_1, styles_1, pickers_1, mobx_1, mobx_react_1, React, ReactDOM, react_hot_loader_1, react_router_dom_1, store_1, RouteStore_1, Environment_1, RequestLogger_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    moment_1 = tslib_1.__importDefault(moment_1);
    CssBaseline_1 = tslib_1.__importDefault(CssBaseline_1);
    React = tslib_1.__importStar(React);
    ReactDOM = tslib_1.__importStar(ReactDOM);
    const App = React.lazy(() => new Promise((resolve_1, reject_1) => { require(['./containers/app'], resolve_1, reject_1); }).then(tslib_1.__importStar));
    (0, mobx_1.configure)({ useProxies: "ifavailable", enforceActions: "never" });
    require("./styles/site.less");
    const logRequests = false;
    if (logRequests) {
        (0, RequestLogger_1.enableRequestLogging)(true);
        setInterval(() => {
            (0, RequestLogger_1.printLoggedRequests)();
        }, 1000 * 30);
    }
    const stores = store_1.StoreManager.Instance;
    if ((0, Environment_1.isLocal)()) {
        const render = (App) => {
            return (React.createElement(react_hot_loader_1.AppContainer, null,
                React.createElement(mobx_react_1.Provider, { stores: stores },
                    React.createElement(styles_1.MuiThemeProvider, { theme: stores.uiStore.Theme },
                        React.createElement(CssBaseline_1.default, null),
                        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_1.default },
                            React.createElement(react_router_dom_1.BrowserRouter, { basename: stores.configStore.BaseUrl },
                                React.createElement(React.Suspense, { fallback: React.createElement("div", null) },
                                    React.createElement(RouteStore_1.RegisterHistory, null),
                                    React.createElement(App, null))))))));
        };
        ReactDOM.render(render(App), document.getElementById("root"));
        if (module.hot) {
            module.hot.accept("./containers/app", () => {
                const HotReloadedApp = require("./containers/app").default;
                console.log("Hot reload app", HotReloadedApp);
                ReactDOM.render(render(React.createElement(HotReloadedApp, null)), document.getElementById("root"));
            });
        }
    }
    else {
        const render = (App) => {
            return (React.createElement(mobx_react_1.Provider, { stores: stores },
                React.createElement(styles_1.MuiThemeProvider, { theme: stores.uiStore.Theme },
                    React.createElement(CssBaseline_1.default, null),
                    React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_1.default },
                        React.createElement(react_router_dom_1.BrowserRouter, { basename: stores.configStore.BaseUrl },
                            React.createElement(React.Suspense, { fallback: React.createElement("div", null) },
                                React.createElement(RouteStore_1.RegisterHistory, null),
                                React.createElement(App, null)))))));
        };
        ReactDOM.render(render(App), document.getElementById("root"));
    }
});
